import { useEffect } from "react";
import { useNavigate } from "react-router";

import "./index.css";

import Str from "../../../helpers/Str";
import Navbar from "../../../components/nav/Navbar";
import Button from "../../button/Button";

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  menuTitle?: string;
  pageTitle?: string;
  innerClassName?: string;
  footer?: boolean;
}

export default function PageContainer({
  children,
  innerClassName,
  menuTitle,
  pageTitle,
  footer,
  ...rest
}: PageContainerProps) {
  const navigate = useNavigate();

  document.title = pageTitle || menuTitle || "Milagre dos peixes";

  return (
    <div {...rest}>
      <Navbar pageTitle={pageTitle || menuTitle} />

      <main className={Str.tw(innerClassName, "grid container mx-auto lg:px-[2rem] min-[320px]:px-1")}>
        {children}
      </main>

      {footer && (
        <div className={"marginTopCalc"}>
          <footer className="dark:bg-gray-800 ">
            <div className="w-full mx-auto p-2 md:flex md:items-center md:justify-end">
              <ul className="flex flex-wrap items-center mt-3 font-outline-2 text-xl outline-font sm:mt-0">
                <li>
                  <Button
                    className="mr-2  md:mr-4 "
                    onClick={() => navigate("/salas")}
                  >
                    Salas
                  </Button>
                </li>
                <li>
                  <Button
                    className="mr-2 md:mr-4"
                    onClick={() => navigate("/alunos-cursos")}
                  >
                    Contratos
                  </Button>
                </li>
              </ul>
            </div>
          </footer>
        </div>
      )}
    </div>
  );
}
